module.exports = __webpack_public_path__ + "static/media/monument_scholar_pin.70ffe5be.png";